import React from "react";
import { CustIcon } from "../Svgs";
import "./Loader.less";

export const Loader = ({className}) => {
  return (
    <div className={`loader_blk w-100 text-center py-5 d-flex align-items-center justify-content-center ${className ?? ""}`}>
      <CustIcon type="loader" />
    </div>
  );
};
